/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { NOT_STARTED } from 'customer-data-objects/engagement/EngagementStatusTypes';
import { STATUS } from 'customer-data-objects/task/TaskPropertyNames';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import { useOnBulkUpdateTasks } from '../../../hooks/tasksBulkActionsHooks/tasksCrud';
import { useBulkActionsHasError } from '../../../hooks/useBulkActionsHasError';
import { useBulkActionsIsLoading } from '../../../hooks/useBulkActionsIsLoading';
import { useBulkActionsPermissionsForCurrentSelection } from '../../../hooks/useBulkActionsPermissionsForCurrentSelection';
import { BaseBulkActionButton } from '../BaseBulkActionButton';
import { genericAlertSuccess } from '../../../alerts/bulkActionsAlerts';
import { jsx as _jsx } from "react/jsx-runtime";
export const UNCOMPLETE_TASK_PROPERTY_UPDATE = [{
  name: STATUS,
  value: NOT_STARTED
}];
export const DefaultBulkActionsUncompleteTasksModalOnSuccess = ({
  count
}) => {
  genericAlertSuccess({
    message: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "bulkActions.alerts.tasks.uncompleteTasks.success",
      options: {
        count
      }
    })
  });
};
export const UncompleteTasks = ({
  buttonProps
}) => {
  const {
    logFunction,
    onSuccess = DefaultBulkActionsUncompleteTasksModalOnSuccess
  } = buttonProps;
  const isLoading = useBulkActionsIsLoading();
  const hasError = useBulkActionsHasError();
  const canBulkEditTasks = useBulkActionsPermissionsForCurrentSelection('canEdit');
  const disabled = isLoading || hasError || !canBulkEditTasks;
  const handleBulkUncomplete = useOnBulkUpdateTasks(logFunction);
  const onClick = useCallback(() => {
    handleBulkUncomplete({
      propertyUpdates: UNCOMPLETE_TASK_PROPERTY_UPDATE,
      onSuccess
    });
  }, [handleBulkUncomplete, onSuccess]);
  return /*#__PURE__*/_jsx(BaseBulkActionButton, {
    disabled: disabled,
    onClick: onClick,
    icon: "remove",
    isLoading: isLoading,
    disabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "bulkActions.buttonDisabledTooltips.tasks.generic"
    }),
    "data-test-id": "bulk-actions-uncomplete-tasks",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "bulkActions.buttonLabels.tasks.uncompleteTasks"
    })
  });
};